<template>
  <el-row :gutter="15">
    <el-col :span="12">
      <p>
        <b>Pickup Type</b><br>
        {{ (pickup.type || '-') | titleize }}
      </p>

      <p>
        <b>Booked At</b><br>
        {{ pickup.created_at ? $moment(pickup.created_at).format('llll') : '-' }}
      </p>

      <p>
        <b>Customer</b><br>
        <span class="text-uppercase">{{ $_.get(pickup, 'account.name', '-') }}</span>
      </p>

      <p>
        <b>Created By</b><br>
        <span class="text-uppercase">{{ $_.get(pickup, 'profile.name', '-') }}</span>
      </p>

      <p>
        <b>Carrier &amp; Service</b><br>
        <span class="text-uppercase">{{ (pickup.carrier && pickup.carrier_service) ? `${pickup.carrier.name} ${pickup.carrier_service.name}` : '-' }}</span>
      </p>

      <p>
        <b>Carrier Cutoff</b><br>
        {{ (pickup.carrier_cut_off_time ? $moment(pickup.carrier_cut_off_time, 'HH:mm:ss').format('hh:mm a') : '-') }}
      </p>

      <p>
        <b>Carrier Response</b><br>
        {{ pickup.carrier_response || '-' }}
      </p>
    </el-col>

    <el-col :span="12">
      <p>
        <b>Charge Account</b><br>
        {{ pickup.charge_account ? pickup.charge_account : '-' }}
      </p>

      <p>
        <b>Special Instructions</b><br>
        {{ pickup.special_instructions || '-' }}
      </p>

      <p>
        <b>Customer Reference</b><br>
        {{ pickup.customer_reference || '-' }}
      </p>

      <p>
        <b>Total Items</b><br>
        {{ `${itemsCount} ${itemsCount > 0 ? 'items' : 'item'}` }}
      </p>

      <p>
        <b>Largest Item</b><br>
        {{ largestItemDimensions.join(' x ') }}cm
      </p>

      <p>
        <b>Total Weight &amp; Volume</b><br>
        {{ itemsWeight }}kg, {{ itemsVolume }}m<sup>3</sup>
      </p>

      <p>
        <b>Carrier Reference</b><br>
        {{ pickup.carrier_reference || '-' }}
      </p>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    pickup: {
      type: Object,
      required: true
    }
  },
  computed: {
    itemsWeight () {
      let weight = 0

      if (this.pickup.consignments.length > 0) {
        this.getPickupItems(this.pickup).map(item => {
          weight += item.item_weight ? parseFloat(item.item_weight) : 0
        })
      } else if (this.pickup.items.length > 0) {
        this.getPickupItems(this.pickup).map(item => {
          weight += item.weight
        })
      }

      return weight
    },
    itemsVolume () {
      let volume = 0

      if (this.pickup.consignments.length > 0) {
        this.getPickupItems(this.pickup).map(item => {
          volume += item.item_cube ? parseFloat(item.item_cube * item.item_qty) : 0
        })
      } else if (this.pickup.items.length > 0) {
        this.getPickupItems(this.pickup).map(item => {
          volume += ((item.length * item.width * item.height) * item.item_count) / 1000000
        })
      }

      return volume
    },
    itemsCount () {
      let count = 0

      if (this.pickup.consignments.length > 0) {
        count = this
          .getPickupItems(this.pickup)
          .map(i => i.item_qty)
          .reduce((total, qty) => total + parseInt(qty), 0)
      } else if (this.pickup.items.length > 0) {
        count = this
          .getPickupItems(this.pickup)
          .map(i => i.item_count)
          .reduce((total, qty) => total + parseInt(qty), 0)
      }

      return count
    },
    largestItemDimensions () {
      let dimension = [0, 0, 0]

      this.getPickupItems(this.pickup).map(item => {
        let length = item.item_length || item.length || 0
        let width = item.item_width || item.width || 0
        let height = item.item_height || item.height || 0

        let _total = length + width + height
        let dimensionTotal = dimension.reduce((total, d) => total + d, 0)
        if (_total > dimensionTotal) {
          dimension[0] = length
          dimension[1] = width
          dimension[2] = height
        }
      })

      return dimension
    }
  },
  methods: {
    getPickupItems (pickup) {
      let items = []
      if (pickup.consignments.length > 0) {
        pickup.consignments.map(con => {
          items = items.concat(con.items)
        })
        return items
      } else if (pickup.items.length > 0) {
        return items.concat(pickup.items)
      } else { return [] }
    }
  }
}
</script>
